import React from "react";

import { AlertCircleOpen } from "/component/base/Icon";
import EmptyStateCta from "/component/partial/EmptyStateCta";
import { useTranslation } from "/hook";
import { layout } from "/styles";

const DocumentsErrorState = () => {
  const { t } = useTranslation("documents");

  return (
    <div css={layout.flexVerticalCenter}>
      <div css={layout.marginVertical(80)}>
        <EmptyStateCta
          icon={<AlertCircleOpen color="brandPrimary" size={48} />}
          title={t("error.fetchError.title")}
          subtitle={t("error.fetchError.subtitle")}
        />
      </div>
    </div>
  );
};

export default DocumentsErrorState;
